import Swiper, {Pagination} from "swiper";

const edgesliders = document.querySelectorAll(".js-keyfactsslider");
if (edgesliders.length > 0) {
    edgesliders.forEach((slider) => {
        new Swiper(slider, {
            modules: [Pagination],
            pagination: {
                clickable: true,
                el: ".swiper-pagination",
                type: "bullets",
                renderBullet: (index, className) =>
                    `<div class="${className}"><div class="swiper-pagination-bullet_inner"></div></div>`,
            },
            slidesPerView: 1.2,
            spaceBetween: 18,
            breakpoints: {
                475: {
                    slidesPerView: 1.4,
                },
                640: {
                    slidesPerView: 1.6,
                    spaceBetween: 24,
                },
                1184: {
                    spaceBetween: 32,
                },
            },
        });
    });
}
